import { Phone, Clock, Mail, MapPin } from "lucide-react";

const TopBar = () => {
  return (
    <div className="hidden sm:block bg-accent text-accent-foreground">
      <div className="container-max flex flex-col sm:flex-row items-center justify-between px-4 py-2 text-xs sm:text-sm gap-1 sm:gap-0">
        <div className="flex items-center gap-4">
          <a href="mailto:jrprocleanersservices@gmail.com" className="flex items-center gap-2 hover:text-primary transition-colors">
            <Mail className="h-3.5 w-3.5 text-secondary" />
            <span>jrprocleanersservices@gmail.com</span>
          </a>
          <div className="hidden md:flex items-center gap-2">
            <Clock className="h-3.5 w-3.5 text-secondary" />
            <span>Mon–Sat 8 AM – 6 PM</span>
          </div>
          <div className="hidden lg:flex items-center gap-2">
            <MapPin className="h-3.5 w-3.5 text-secondary" />
            <span>Tampa, FL</span>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <a href="tel:9785645018" className="flex items-center gap-2 hover:text-primary transition-colors font-semibold">
            <Phone className="h-3.5 w-3.5 text-secondary" />
            <span>(978) 564-5018</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
